/**
 * View Transitions support.
 *
 * For color scheme: call `withViewTransition(fn)` to wrap the change.
 * For navigation: CSS `@view-transition { navigation: auto }` handles
 * same-origin navigations automatically in supporting browsers.
 */

export function withViewTransition(fn: () => void): void {
  if (document.startViewTransition) {
    // Swallow the benign rejection the API throws when a transition is skipped
    // (e.g. the document unloads mid-transition — happens when a Storybook
    // gallery iframe reloads on a theme switch). It carries no actionable info.
    document.startViewTransition(fn).finished.catch(() => {})
  } else {
    fn()
  }
}
